import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useMemo } from 'react'

export const useSpaceAddress = (
	space?: Pick<Space, 'address'>,
	dense?: boolean,
) => {
	const fullAddress = useMemo(() => {
		const { address1, address2, postal_code, city } = space?.address ?? {}

		const address = [address1]

		if (address2 && !dense) address.push(address2)
		if (postal_code && city) address.push(`${postal_code} ${city}`)

		return address.filter(Boolean).join(', ')
	}, [space, dense])

	return {
		fullAddress,
	}
}
